import {
    CLICK_INSURANCE_SLIDEOUT_BUTTON,
    VIEW_INSURANCE_SLIDEOUT,
    CLOSE_INSURANCE_SLIDEOUT,
    SELECT_INSURANCE_PROVIDER_NAME,
    SEARCH_INSURANCE_PROVIDER_NAME,
    AUTOCOMPLETE_INSURANCE_PROVIDER_NAME,
    SAVE_INSURANCE_PROVIDER,
    CANCEL_INSURANCE_PROVIDER
} from '../actionTypes/insuranceActionTypes';

export const insuranceSlideoutButton = () => ({
    type: CLICK_INSURANCE_SLIDEOUT_BUTTON
});

export const viewInsuranceSlideout = () => ({
    type: VIEW_INSURANCE_SLIDEOUT
});

export const closeInsuranceSlideout = () => ({
    type: CLOSE_INSURANCE_SLIDEOUT
});

export const selectInsuranceProviderName = () => ({
    type: SELECT_INSURANCE_PROVIDER_NAME
});

export const searchInsuranceProviderName = () => ({
    type: SEARCH_INSURANCE_PROVIDER_NAME
});

export const autocompleteInsuranceProviderName = () => ({
    type: AUTOCOMPLETE_INSURANCE_PROVIDER_NAME
});

export const saveInsuranceProvider = () => ({
    type: SAVE_INSURANCE_PROVIDER
});

export const cancelInsuranceProvider = () => ({
    type: CANCEL_INSURANCE_PROVIDER
});
